export const createReduxAction = (type, payload) => ({ type, payload });
